import type { MapLocation } from '~/composables/map'

export const toLngLat = (o: MapLocation | [number, number]): MapLocation => {
  return Array.isArray(o) ? { lng: o[0], lat: o[1] } : o
}
